import React, { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import clock from '../../assets/clock-gray.svg';
import clockRed from '../../assets/clock-red.svg';

import styles from './_ExpirationLabel.module.css';

interface ExpirationLabelProps {
    className?: string;
    withIcon?: boolean;
    variant?: 'default' | 'warning';
}

export const ExpirationLabel: FC<PropsWithChildren<ExpirationLabelProps>> = ({
    className,
    withIcon,
    variant = 'default',
    children,
}) => (
    <span className={classnames(styles.root, styles[variant], className)}>
        {withIcon && (
            <img
                alt=""
                role="presentation"
                src={variant === 'default' ? clock : clockRed}
                className={styles.icon}
            />
        )}
        <span className={styles.text}>{children}</span>
    </span>
);
